import { parseBooleanString, parseInteger } from "../../util/utility";
import { CXoneEvent } from './agent/cxone-event';

/**
 * Model class for agent state
 */
export class AgentStateResponse extends CXoneEvent {

    /**
     * @remarks  ID of Agent
     */
    public agentId!: number;

    /**
     * @remarks  Name of state for the Agent
     */
    public agentStateName!: string;


    /**
     * @remarks  ID of active Contact if any
     */
    public contactId!: number;


    /**
     * @remarks  Agent first name
     */
    public firstName!: string;


    /**
     * @remarks  Indicates if agent is in ACTIVE state
     */
    public isActive!: boolean;


    /**
     * @remarks  Indicates if active Contact is using an outbound Skill
     */
    public isOutbound!: boolean;


    /**
     * @remarks  Agent last name
     */
    public lastName!: string;


    /**
     * @remarks  ISO 8601 timestamp of last database poll. Value should be passed in "updatedSince" parameter on next call
     */
    public lastPollTime!: Date;


    /**
     * @remarks  Time of last record update
     */
    public lastUpdateTime!: Date;


    /**
     * @remarks  Channel name of Contact if any
     */
    public mediaName!: string;


    /**
     * @remarks  ID for Unavailable state
     */
    public outStateCode!: number;


    /**
     * @remarks  Name of Unavailable state
     */
    public outStateDescription!: string;


    /**
     * @remarks  ID of Skill Agent is working on
     */
    public skillId!: string;


    /**
     * @remarks  Name of Skill Agent is working on
     */
    public skillName!: string;


    /**
     * @remarks  ISO 8601 time the Agent started on current Skill
     */
    public startDate!: Date;


    /**
     * @remarks  Agent Phone for current session
     */
    public stationPhoneNumber!: number;


    /**
     * @remarks  ID of Agent Team
     */
    public teamId!: number;


    /**
     * @remarks  Name of Agent Team
     */
    public teamName!: string;


    /**
     * @remarks   
     */
    public userName!: string;

    /**
     * This method to parse agent state response
     * @param data - agent state object
     * @example -
     * ```
     * parse(data);
     * ```
     */
    parse(data: { [key: string]: string }): void {
        this.agentId = parseInteger(data.agentId);
        this.agentStateName = data.agentStateName;
        this.contactId = parseInteger(data.contactId);
        this.firstName = data.firstName;
        this.isActive = parseBooleanString(data.isActive);
        this.isOutbound = parseBooleanString(data.isOutbound);
        this.lastName = data.lastName;
        this.lastPollTime = new Date(data.lastPollTime);
        this.lastUpdateTime = new Date(data.lastUpdateTime);
        this.mediaName = data.mediaName;
        this.outStateCode = parseInteger(data.outStateCode);
        this.outStateDescription = data.outStateDescription;
        this.skillId = data.skillId;
        this.skillName = data.skillName;
        this.startDate = new Date(data.startDate);
        this.stationPhoneNumber = parseInteger(data.stationPhoneNumber);
        this.teamId = parseInteger(data.teamId);
        this.teamName = data.teamName;
        this.userName = data.userName;
    }

};
